export default {
	home: {
		id: 'home',
		label: '主页',
		path: '/main/home',
		children: {
			restaurantOrders: {
				id: 'restaurantOrders',
				label: '餐企订单',
				path: '/main/restaurantOrders',
				parentId: 'home',
				children: {
					restaurantOrderDetails: {
						id: 'restaurantOrderDetails',
						label: '餐企订单详情',
						path: '/main/home',
						parentId: 'restaurantOrders'
					}
				}
			},
			restaurantReturns: {
				id: 'restaurantReturns',
				label: '餐企退单',
				path: '/main/restaurantReturns',
				parentId: 'home',
				children: {
					restaurantReturnDetails: {
						id: 'restaurantReturnDetails',
						label: '餐企退单详情',
						path: '/main/home',
						parentId: 'restaurantReturns'
					}
				}
			},
			restaurantQuotations: {
				id: 'restaurantQuotations',
				label: '餐企报价单',
				path: '/main/restaurantQuotations',
				parentId: 'home',
				children: {
					restaurantQuotationDetails: {
						id: 'restaurantQuotationDetails',
						label: '餐企报价单详情',
						path: '/main/home',
						parentId: 'restaurantQuotations'
					}
				}
			},
			restaurantAccount: {
				id: 'restaurantAccount',
				label: '餐企对账单',
				path: '/main/restaurantAccount',
				parentId: 'home',
				children: {
					restaurantAccountDetails: {
						id: 'restaurantAccountDetails',
						label: '餐企对账单详情',
						path: '/main/home',
						parentId: 'restaurantAccount'
					}
				}
			},
			systemSet: {
				id: 'systemSet',
				label: '系统参数',
				path: '/main/systemSet',
				parentId: 'home'
			},
			notify: {
				id: 'notify',
				label: '系统消息',
				path: '/main/notify',
				parentId: 'home'
			},
			reportCenter: {
				id: 'reportform',
				label: '报表中心',
				path: '/main/reportform',
				parentId: 'home'
			}
		}
	}
}
